var gql = require("@apollo/client").gql;

const SEARCH_REGIONS_MOSKVAONLINE = gql`
	{
		districts(region_url: "moskovskaya-oblast") {
			data {
				id
				name
				region {
					id
				}
			}
		}
	}
`;

export default SEARCH_REGIONS_MOSKVAONLINE;
